module.exports = __webpack_public_path__ + "assets/img/member.96c35f3a.png";